<template>
  <div class="main-header">
    <!-- Left Column -->
    <router-link to="/dashboard">
      <div class="logo">
        <img :src="image" alt="Takaful Brunei" />
      </div>
    </router-link>
    <div class="menu-toggle">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <!-- Middle Column -->
    <div id="system-title" class="d-none d-sm-block" style="margin: auto;">
      Takaful Brunei Mobile System
    </div>

    <!-- Right Column -->
    <div class="header-part-right">
      <div class="dropdown">
        <div class="user col align-self-end">
          <!-- Logged In User's Name -->
          <div
            id="user-name-header"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="cursor: pointer;"
          >
            {{ user.name }}
            <i class="fa fa-chevron-down"></i>
          </div>

          <!-- Logout Link -->
          <div
            aria-labelledby="userDropdown"
            class="dropdown-menu dropdown-menu-right"
          >
            <a @click="logout" class="dropdown-item" style="cursor: pointer;"
              >Logout</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Auth from "@/services/Auth";

const auth = new Auth();
const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

export default {
  name: "TopNavComponent",
  components: {},

  data() {
    return {
      user: [],
      image: require("@/assets/icons/logo-tb.png")
    };
  },

  methods: {
    loadUser() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/auth/user", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.user = res.data;
          })
          .catch(err => {
            this.$router.push("/login");

            localStorage.clear();
          });
      }
    },

    logout() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/auth/logout", {}, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.$router.push("/login");

            localStorage.clear();

            swal({
              text: "Logout successful!",
              icon: "success",
              button: "OK"
            });
          });
      }
    }
  },

  mounted() {
    this.loadUser();

    setTimeout(function() {
      // alert("Hello");
      auth.check();
    }, 1000 * 60 * 5);
  }
};
</script>
